import "./insHorizontalBarDatapointChart.scss";
import React from "react";
import { InsBaseHorizontalBarChart } from "./insBaseHorizontalBarChart";
import { useGetHorizontalBarChartConfig } from "./use-get-horizontal-bar-chart-config";
export const InsHorizontalBarComparisonChart = (props) => {
    const config = useGetHorizontalBarChartConfig(props), { options } = config;
    if (options) {
        const { yAxis } = options;
        if (yAxis && !Array.isArray(yAxis)) {
            const originalAxis = options.yAxis;
            options.yAxis = [
                { ...originalAxis, softMax: config.additionalData?.max?.[0], softMin: config.additionalData?.min?.[0], width: "40%" },
                { ...originalAxis, left: "50%", offset: 0, softMax: config.additionalData?.max?.[1], softMin: config.additionalData?.min?.[1], width: "40%" }
            ];
        }
        const diffIndex = config.additionalData?.differenceIndex;
        if (diffIndex || diffIndex === 0) {
            const diff = options.series?.[diffIndex];
            if (diff) {
                diff.className = "highcharts-difference-series";
                diff.yAxis = 1;
            }
        }
    }
    return React.createElement(InsBaseHorizontalBarChart, { ...props, ...config, options: options, hasData: config.series.length > 2 && config.series.every((s) => s.length > 0) });
};
